import React from 'react';
import './quantia.css';

/**
 * Bloque hero "premium" sobre fondo negro Quantia con halos radiales
 * decorativos. Usado en Login y Home para reforzar la identidad de marca.
 *
 * Props:
 *  - badge:        nodo opcional. Si se pasa string, se renderiza con dot lime.
 *  - title:        nodo. Puedes incluir <em> para resaltar fragmentos en lime.
 *  - body:         string/nodo descriptivo
 *  - actions:      nodo (botones u otros CTAs)
 *  - children:     contenido custom adicional debajo
 *  - compact:      bool. Reduce paddings (útil en login).
 *  - className:    extra className para el wrapper
 */
const HeroSection = ({
  badge,
  title,
  body,
  actions,
  children,
  compact = false,
  className = '',
}) => {
  return (
    <section className={`qa-hero ${compact ? 'qa-hero--compact' : ''} ${className}`}>
      <div className="qa-hero__inner">
        {badge && (
          typeof badge === 'string' ? (
            <span className="qa-hero__badge">
              <span className="qa-hero__badge-dot" />
              {badge}
            </span>
          ) : (
            <div className="qa-hero__badge-wrap">{badge}</div>
          )
        )}

        {title && <h1 className="qa-hero__title">{title}</h1>}
        {body && <p className="qa-hero__body">{body}</p>}
        {actions && <div className="qa-hero__actions">{actions}</div>}
        {children}
      </div>
    </section>
  );
};

export default HeroSection;
